import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ContentProps {
  contentClasses?: string;
  children: React.ReactNode;
}

const ContentContainer = ({ contentClasses, children }: ContentProps) => {
  const contentClassNames = twMerge(
    'overflow-auto',
    'md:h-[calc(100vh-6.7rem)]',
    'lg:h-[calc(100vh-3.5rem)]',
    `${contentClasses ?? ''}`
  );

  return <div className={contentClassNames}>{children}</div>;
};

export default ContentContainer;
